<template>
  <div class="nav container" v-if="!$root.isMobile && navigation" :class="{'is-black': black, 'is-home': home}">
    <div class="nav__inner">
      <div class="nav__logo">
        <router-link :to="`/${$i18n.locale}/sculptures`" class="nav__logo__link">
          <!-- <img src="../assets/images/logo-black.png" alt="Patrick roger logo black" class="nav__logo__img" v-if="black">
          <img src="../assets/images/logo-white.png" alt="Patrick roger logo white" class="nav__logo__img" v-else> -->
		  <svg class="nav__logo__svg" :class="{'is-black': black}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 347.04 29.33"><path d="M247.23,311.23V282.87h10.86a11.54,11.54,0,0,1,4.31.73,7,7,0,0,1,2.86,2,8.38,8.38,0,0,1,1.5,2.7,9.9,9.9,0,0,1,.49,3.12,8.61,8.61,0,0,1-2.29,5.91q-2.29,2.55-6.87,2.55h-7.33v11.39Zm11.1-14.67A5,5,0,0,0,262.4,295a5.4,5.4,0,0,0,1.32-3.64,5.73,5.73,0,0,0-1.25-3.65,5,5,0,0,0-4.14-1.58h-7.57v10.41Z" transform="translate(-247.23 -282.38)"/><path d="M290.5,311.23l-2.43-6.93H276.81l-2.39,6.93h-3.69l10-28.36h3.28l10,28.36ZM287,301.18l-3.64-10.49a28.38,28.38,0,0,1-.89-2.88c-.3,1.06-.6,2-.89,2.88l-3.69,10.49Z" transform="translate(-247.23 -282.38)"/><path d="M309.94,286.23v25h-3.52v-25h-7.9v-3.36h19.32v3.36Z" transform="translate(-247.23 -282.38)"/><path d="M328,311.23V282.87h11.18q4.69,0,6.83,2.31a8.66,8.66,0,0,1,.48,10.75,7.86,7.86,0,0,1-5,2.9l6.08,12.4h-4l-5.84-12.16h-6.28v12.16Zm3.52-15.44h7.74a5.24,5.24,0,0,0,4-1.38,4.8,4.8,0,0,0,1.28-3.4,5.13,5.13,0,0,0-1.24-3.4,5.07,5.07,0,0,0-4.07-1.46h-7.74Z" transform="translate(-247.23 -282.38)"/><path d="M359.08,311.23V282.87h3.52v28.36Z" transform="translate(-247.23 -282.38)"/><path d="M385.21,311.71a11.39,11.39,0,0,1-5.43-1.25,9.49,9.49,0,0,1-3.69-3.41,16.49,16.49,0,0,1-2-4.66,21.35,21.35,0,0,1-.65-5.34,20.59,20.59,0,0,1,.67-5.33,16.34,16.34,0,0,1,2-4.66,10,10,0,0,1,3.69-3.4,11,11,0,0,1,5.37-1.28q6.65,0,9.15,5.11l-3.16,1.62a8.52,8.52,0,0,0-2.49-2.57,6.37,6.37,0,0,0-3.5-.88,6.62,6.62,0,0,0-4.78,1.83,9.53,9.53,0,0,0-2.62,4.27,19.11,19.11,0,0,0-.71,5.29,14.91,14.91,0,0,0,2.07,8,6.67,6.67,0,0,0,6,3.34,6.82,6.82,0,0,0,6.15-3.61L394.6,306a9.61,9.61,0,0,1-3.52,4.15A10.39,10.39,0,0,1,385.21,311.71Z" transform="translate(-247.23 -282.38)"/><path d="M421.7,311.23l-8.42-15.6-4.82,5.91v9.69h-3.53V282.87h3.53v13.89l11.06-13.89h4l-7.82,9.8,10.13,18.56Z" transform="translate(-247.23 -282.38)"/><path d="M449.29,311.23V282.87h11.18q4.69,0,6.83,2.31a8.66,8.66,0,0,1,.48,10.75,7.83,7.83,0,0,1-5,2.9l6.08,12.4h-4l-5.84-12.16h-6.27v12.16Zm3.53-15.44h7.73a5.24,5.24,0,0,0,4-1.38,4.8,4.8,0,0,0,1.28-3.4,4.68,4.68,0,0,0-5.31-4.86h-7.73Z" transform="translate(-247.23 -282.38)"/><path d="M491.1,311.71a11.79,11.79,0,0,1-5.61-1.27,9.61,9.61,0,0,1-3.77-3.45,16.24,16.24,0,0,1-2-4.66,21.81,21.81,0,0,1,0-10.57,16.48,16.48,0,0,1,2-4.66,9.66,9.66,0,0,1,3.77-3.44,11.79,11.79,0,0,1,5.61-1.28,12.41,12.41,0,0,1,4.67.85,9.92,9.92,0,0,1,3.45,2.27,12.7,12.7,0,0,1,2.27,3.37,16.52,16.52,0,0,1,1.29,4,23,23,0,0,1,0,8.43,16.74,16.74,0,0,1-1.29,4,12.48,12.48,0,0,1-2.27,3.36,9.79,9.79,0,0,1-3.45,2.27A12.22,12.22,0,0,1,491.1,311.71Zm-3.91-4.29a7.64,7.64,0,0,0,3.91,1,7.44,7.44,0,0,0,3.93-1,7.2,7.2,0,0,0,2.63-2.74A14.26,14.26,0,0,0,499,301a17.84,17.84,0,0,0,.44-3.95,18.56,18.56,0,0,0-.75-5.45,9,9,0,0,0-2.71-4.19,7.16,7.16,0,0,0-4.92-1.75,7.3,7.3,0,0,0-3.91,1,7.21,7.21,0,0,0-2.62,2.75,15.21,15.21,0,0,0-1.39,3.63,16.66,16.66,0,0,0-.47,4,18.28,18.28,0,0,0,.45,4.13,12.82,12.82,0,0,0,1.39,3.6A7.12,7.12,0,0,0,487.19,307.42Z" transform="translate(-247.23 -282.38)"/><path d="M524.72,311.71a11.75,11.75,0,0,1-5.49-1.23,10,10,0,0,1-3.77-3.35,15.53,15.53,0,0,1-2.08-4.65,20.77,20.77,0,0,1-.69-5.43,19.63,19.63,0,0,1,.73-5.41,16,16,0,0,1,2.14-4.66,10.41,10.41,0,0,1,3.79-3.34,11.26,11.26,0,0,1,5.37-1.26,10.48,10.48,0,0,1,5.69,1.34,11.14,11.14,0,0,1,3.5,3.65l-3.16,1.82a9.07,9.07,0,0,0-2.51-2.57,6.24,6.24,0,0,0-3.52-.91,7.55,7.55,0,0,0-3.28.68,6.85,6.85,0,0,0-2.39,1.81,10.15,10.15,0,0,0-1.56,2.61,13.52,13.52,0,0,0-.89,3.06,18.61,18.61,0,0,0-.27,3.18,14.56,14.56,0,0,0,2.11,8,7,7,0,0,0,6.28,3.26,6.13,6.13,0,0,0,4.62-1.8,6.52,6.52,0,0,0,1.74-4.72v-1.14h-5.15v-3.24h8.84v3.41c0,3.43-.94,6.09-2.82,8A9.73,9.73,0,0,1,524.72,311.71Z" transform="translate(-247.23 -282.38)"/><path d="M545.82,311.23V282.87h16.86v3.32H549.35v8.71h8.79v3.32h-8.79v9.64h14.22v3.37Z" transform="translate(-247.23 -282.38)"/><path d="M574.14,311.23V282.87h11.18q4.7,0,6.83,2.31a8.66,8.66,0,0,1,.48,10.75,7.86,7.86,0,0,1-5,2.9l6.08,12.4h-4l-5.84-12.16h-6.28v12.16Zm3.52-15.44h7.74a5.24,5.24,0,0,0,4-1.38,4.8,4.8,0,0,0,1.28-3.4,4.68,4.68,0,0,0-5.31-4.86h-7.74Z" transform="translate(-247.23 -282.38)"/></svg>
        </router-link>
      </div>
      <ul class="nav__links">
        <router-link class="nav__link" :to="`/${$i18n.locale}${ item.url }`" v-for="(item, index) in navigation.header_sculptures_links" :key="index">{{ item.label }}</router-link>
        <router-link :to="`/${$i18n.locale}${navigation.header_sculptures_home_link_path}`" class="nav__link nav__link--menu">{{ navigation.header_sculptures_home_link }}</router-link>
      </ul>
    </div>
  </div>

  <div class="nav-mobile container" :class="{'is-black': black}" v-else-if="$root.isMobile && navigation">
    <div class="nav-mobile__header">
      <router-link :to="`/${$i18n.locale}/`" class="nav-mobile__logo">
        <!-- <img src="../assets/images/logo-black.png" alt="Patrick roger logo black" class="nav__logo__img" v-if="black">
        <img src="../assets/images/logo-white.png" alt="Patrick roger logo white" class="nav__logo__img" v-else> -->
		<svg class="nav__logo__svg--mobile" :class="{'is-black': black}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 347.04 29.33"><path d="M247.23,311.23V282.87h10.86a11.54,11.54,0,0,1,4.31.73,7,7,0,0,1,2.86,2,8.38,8.38,0,0,1,1.5,2.7,9.9,9.9,0,0,1,.49,3.12,8.61,8.61,0,0,1-2.29,5.91q-2.29,2.55-6.87,2.55h-7.33v11.39Zm11.1-14.67A5,5,0,0,0,262.4,295a5.4,5.4,0,0,0,1.32-3.64,5.73,5.73,0,0,0-1.25-3.65,5,5,0,0,0-4.14-1.58h-7.57v10.41Z" transform="translate(-247.23 -282.38)"/><path d="M290.5,311.23l-2.43-6.93H276.81l-2.39,6.93h-3.69l10-28.36h3.28l10,28.36ZM287,301.18l-3.64-10.49a28.38,28.38,0,0,1-.89-2.88c-.3,1.06-.6,2-.89,2.88l-3.69,10.49Z" transform="translate(-247.23 -282.38)"/><path d="M309.94,286.23v25h-3.52v-25h-7.9v-3.36h19.32v3.36Z" transform="translate(-247.23 -282.38)"/><path d="M328,311.23V282.87h11.18q4.69,0,6.83,2.31a8.66,8.66,0,0,1,.48,10.75,7.86,7.86,0,0,1-5,2.9l6.08,12.4h-4l-5.84-12.16h-6.28v12.16Zm3.52-15.44h7.74a5.24,5.24,0,0,0,4-1.38,4.8,4.8,0,0,0,1.28-3.4,5.13,5.13,0,0,0-1.24-3.4,5.07,5.07,0,0,0-4.07-1.46h-7.74Z" transform="translate(-247.23 -282.38)"/><path d="M359.08,311.23V282.87h3.52v28.36Z" transform="translate(-247.23 -282.38)"/><path d="M385.21,311.71a11.39,11.39,0,0,1-5.43-1.25,9.49,9.49,0,0,1-3.69-3.41,16.49,16.49,0,0,1-2-4.66,21.35,21.35,0,0,1-.65-5.34,20.59,20.59,0,0,1,.67-5.33,16.34,16.34,0,0,1,2-4.66,10,10,0,0,1,3.69-3.4,11,11,0,0,1,5.37-1.28q6.65,0,9.15,5.11l-3.16,1.62a8.52,8.52,0,0,0-2.49-2.57,6.37,6.37,0,0,0-3.5-.88,6.62,6.62,0,0,0-4.78,1.83,9.53,9.53,0,0,0-2.62,4.27,19.11,19.11,0,0,0-.71,5.29,14.91,14.91,0,0,0,2.07,8,6.67,6.67,0,0,0,6,3.34,6.82,6.82,0,0,0,6.15-3.61L394.6,306a9.61,9.61,0,0,1-3.52,4.15A10.39,10.39,0,0,1,385.21,311.71Z" transform="translate(-247.23 -282.38)"/><path d="M421.7,311.23l-8.42-15.6-4.82,5.91v9.69h-3.53V282.87h3.53v13.89l11.06-13.89h4l-7.82,9.8,10.13,18.56Z" transform="translate(-247.23 -282.38)"/><path d="M449.29,311.23V282.87h11.18q4.69,0,6.83,2.31a8.66,8.66,0,0,1,.48,10.75,7.83,7.83,0,0,1-5,2.9l6.08,12.4h-4l-5.84-12.16h-6.27v12.16Zm3.53-15.44h7.73a5.24,5.24,0,0,0,4-1.38,4.8,4.8,0,0,0,1.28-3.4,4.68,4.68,0,0,0-5.31-4.86h-7.73Z" transform="translate(-247.23 -282.38)"/><path d="M491.1,311.71a11.79,11.79,0,0,1-5.61-1.27,9.61,9.61,0,0,1-3.77-3.45,16.24,16.24,0,0,1-2-4.66,21.81,21.81,0,0,1,0-10.57,16.48,16.48,0,0,1,2-4.66,9.66,9.66,0,0,1,3.77-3.44,11.79,11.79,0,0,1,5.61-1.28,12.41,12.41,0,0,1,4.67.85,9.92,9.92,0,0,1,3.45,2.27,12.7,12.7,0,0,1,2.27,3.37,16.52,16.52,0,0,1,1.29,4,23,23,0,0,1,0,8.43,16.74,16.74,0,0,1-1.29,4,12.48,12.48,0,0,1-2.27,3.36,9.79,9.79,0,0,1-3.45,2.27A12.22,12.22,0,0,1,491.1,311.71Zm-3.91-4.29a7.64,7.64,0,0,0,3.91,1,7.44,7.44,0,0,0,3.93-1,7.2,7.2,0,0,0,2.63-2.74A14.26,14.26,0,0,0,499,301a17.84,17.84,0,0,0,.44-3.95,18.56,18.56,0,0,0-.75-5.45,9,9,0,0,0-2.71-4.19,7.16,7.16,0,0,0-4.92-1.75,7.3,7.3,0,0,0-3.91,1,7.21,7.21,0,0,0-2.62,2.75,15.21,15.21,0,0,0-1.39,3.63,16.66,16.66,0,0,0-.47,4,18.28,18.28,0,0,0,.45,4.13,12.82,12.82,0,0,0,1.39,3.6A7.12,7.12,0,0,0,487.19,307.42Z" transform="translate(-247.23 -282.38)"/><path d="M524.72,311.71a11.75,11.75,0,0,1-5.49-1.23,10,10,0,0,1-3.77-3.35,15.53,15.53,0,0,1-2.08-4.65,20.77,20.77,0,0,1-.69-5.43,19.63,19.63,0,0,1,.73-5.41,16,16,0,0,1,2.14-4.66,10.41,10.41,0,0,1,3.79-3.34,11.26,11.26,0,0,1,5.37-1.26,10.48,10.48,0,0,1,5.69,1.34,11.14,11.14,0,0,1,3.5,3.65l-3.16,1.82a9.07,9.07,0,0,0-2.51-2.57,6.24,6.24,0,0,0-3.52-.91,7.55,7.55,0,0,0-3.28.68,6.85,6.85,0,0,0-2.39,1.81,10.15,10.15,0,0,0-1.56,2.61,13.52,13.52,0,0,0-.89,3.06,18.61,18.61,0,0,0-.27,3.18,14.56,14.56,0,0,0,2.11,8,7,7,0,0,0,6.28,3.26,6.13,6.13,0,0,0,4.62-1.8,6.52,6.52,0,0,0,1.74-4.72v-1.14h-5.15v-3.24h8.84v3.41c0,3.43-.94,6.09-2.82,8A9.73,9.73,0,0,1,524.72,311.71Z" transform="translate(-247.23 -282.38)"/><path d="M545.82,311.23V282.87h16.86v3.32H549.35v8.71h8.79v3.32h-8.79v9.64h14.22v3.37Z" transform="translate(-247.23 -282.38)"/><path d="M574.14,311.23V282.87h11.18q4.7,0,6.83,2.31a8.66,8.66,0,0,1,.48,10.75,7.86,7.86,0,0,1-5,2.9l6.08,12.4h-4l-5.84-12.16h-6.28v12.16Zm3.52-15.44h7.74a5.24,5.24,0,0,0,4-1.38,4.8,4.8,0,0,0,1.28-3.4,4.68,4.68,0,0,0-5.31-4.86h-7.74Z" transform="translate(-247.23 -282.38)"/></svg>
      </router-link>
      <router-link :to="`/${$i18n.locale}${navigation.header_sculptures_home_link_path}`" class="nav-mobile__link--home">
        {{ navigation.header_sculptures_home_link }}
      </router-link>
    </div>
    <div class="nav-mobile__links">
      <router-link class="nav-mobile__link" :to="`/${$i18n.locale}${ item.url }`" v-for="(item, index) in navigation.header_sculptures_links" :key="index">{{ item.label }}</router-link>
    </div>
  </div>
</template>

<script>
import EventHub from '@/utils/EventHub.js'

import NavigationMixin from '@/mixins/NavigationMixin.js'

export default {
  name: 'NavSculptures',

  mixins: [NavigationMixin],

  components: {
    
  },

  props: {
    black: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      home: false
    }
  },

  created() {
    this.addListeners()
    this.onRouteChange(this.$route)
  },

  destroyed() {
    this.removeListeners()
  },

  methods: {
    /**
     * 
     * Listeners
     */
    addListeners() {
      EventHub.$on('application:on-route-change', this.onRouteChange)
    },

    removeListeners() {
      EventHub.$off('application:on-route-change', this.onRouteChange)
    },

    /**
     * 
     * Events
     */
    onRouteChange(to) {
      if(to.name === "SculpturesHome")
      {
        this.home = true
      }
      else
      {
        this.home = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.nav
  z-index 2
  position absolute
  top 80px

  color $white
  font-weight 100
  letter-spacing 0.060em

  &.is-black
    color $black

.nav.container
  padding 0 100px 0 150px
  max-width none

  @media(max-width $breakpoints.xl)
    padding 0 75px 0 100px

  @media(max-width $breakpoints.lg)
    padding 0 50px 0 50px

  @media(max-width $breakpoints.md)
    padding 0 10%

  &.is-black
    padding 0 100px

.nav__inner
  display flex
  justify-content space-between
  align-items center

  width 100%

.nav__logo__link
    display block
    width 100%

    @media(max-width $breakpoints.xl)
      width 300px

    @media(max-width $breakpoints.lg)
      width 250px

.nav__logo__svg
	fill $white
	width 345px

	&.is-black
		fill $black

.nav__logo__svg--mobile
	fill $white
	width 140px

	&.is-black
		fill $black

.nav__link
  display inline-block

  padding 0px 20px

  text-transform uppercase
  font-size 18px

  opacity 0.3

  transition opacity 0.3s $ease-out-quart

  .is-black &
    opacity 0.6

    &:hover
      opacity 0.8

  .is-home &
    opacity 1

    &:hover
      opacity 1

  &:hover
    opacity 0.5

  &.router-link-active
    opacity 1

  @media(max-width $breakpoints.xl)
    font-size 17px

  @media(max-width $breakpoints.lg)
    font-size 16px

.nav__link--menu
  position relative

  padding 0px 25px 0px 80px

  opacity 1

  @media(max-width $breakpoints.xl)
    padding-left 50px

  @media(max-width $breakpoints.lg)
    padding-left 25px

  &:after
    content ''

    position absolute
    right 0
    top 50%
  
    height 50px
    width 1px

    background $white

    transform translateY(-50%)

    .is-black &
      background $black

.nav-mobile
  z-index 2
  position absolute
  top 40px

  &.is-black
    color $black

.nav-mobile__header
  display flex
  justify-content space-between
  align-items center

  width 100%
  margin-bottom 25px

.nav-mobile__logo
  display block
  width 50%

.nav-mobile__link--home
  position relative

  padding 10px 20px 10px 0

  color $white
  text-transform uppercase
  line-height 1

  &:after
    content ''
    position absolute
    top 0
    right 0

    height 100%
    width 1px

    background $white

    .is-black &
      background $black

  .is-black &
    color $black

.nav-mobile__logo__img
  display block
  width 100%

.nav-mobile__links
  display flex
  flex-direction column

  text-transform uppercase
  color $white

  .is-black &
    color $black

.nav-mobile__link
  padding 15px 0



</style>